import React from 'react';
import Input from '../../../components/ui/Input';

const UploadedDocumentFilters = ({ search, onSearchChange }) => (
  <div className="px-4 md:px-6 py-3 border-b border-border bg-muted/20">
    <Input
      type="search"
      placeholder="Buscar por nome do documento…"
      value={search}
      onChange={(e) => onSearchChange(e.target.value)}
      className="w-full max-w-xl"
      aria-label="Buscar documentos por nome"
    />
  </div>
);

export default UploadedDocumentFilters;
